import { BlurBackgroundView } from "@quest/murka-games-behavior-leopard/dist";


export class BlurBackgroundViewGame extends BlurBackgroundView{
    
}